import React from 'react'

import { CaretIcon } from './icons'
import {
    Caret,
    MetaIcon,
    PrimaryIcon,
    SelectContainer,
    SelectLabel,
    SelectLeft,
    SelectMenu,
    SelectMeta,
    SelectOption,
    SelectTrigger,
} from './styles'
import cateringIconUrl from '../../assets/icons/catering.svg'
import officeIconUrl from '../../assets/icons/office_ios.svg'

import type { OfficeOption } from '../../models/rooms'

type OfficeSelectProps = {
    offices: OfficeOption[]
    selectedOffice: OfficeOption | null
    isOpen: boolean
    containerRef: React.RefObject<HTMLDivElement | null>
    onToggle: () => void
    onSelect: (officeId: string) => void
}

export function OfficeSelect({
    offices,
    selectedOffice,
    isOpen,
    containerRef,
    onToggle,
    onSelect,
}: OfficeSelectProps) {
    return (
        <SelectContainer ref={containerRef}>
            <SelectTrigger
                type="button"
                aria-expanded={isOpen}
                aria-controls="office-options"
                $expanded={isOpen}
                onClick={onToggle}
            >
                <SelectLeft>
                    <PrimaryIcon src={officeIconUrl} alt="" aria-hidden="true" />
                    <SelectLabel>{selectedOffice?.name || 'Select office'}</SelectLabel>
                    <MetaIcon src={cateringIconUrl} alt="" aria-hidden="true" />
                </SelectLeft>
                <Caret $expanded={isOpen}>
                    <CaretIcon />
                </Caret>
            </SelectTrigger>

            {isOpen ? (
                <SelectMenu id="office-options" role="listbox" aria-label="Offices">
                    {offices.map((office) => (
                        <SelectOption
                            key={office.id}
                            type="button"
                            $active={office.id === selectedOffice?.id}
                            onClick={() => onSelect(office.id)}
                        >
                            <SelectLeft>
                                <PrimaryIcon src={officeIconUrl} alt="" aria-hidden="true" />
                                <SelectLabel>{office.name}</SelectLabel>
                            </SelectLeft>
                            <SelectMeta>{office.hours}</SelectMeta>
                        </SelectOption>
                    ))}
                </SelectMenu>
            ) : null}
        </SelectContainer>
    )
}
